<div class="result-payment-comp-wrapper">
  <app-header-hifpt></app-header-hifpt>
  <div class="body-wrapper">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-wrapper">
          <img *ngIf="status === 'SUCCESS'" src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/tick-circle.png" alt="" width="auto"
            height="auto" />
          <img *ngIf="status !== 'SUCCESS'" src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/swap-wifi6/swap-browser/close-circle.png" alt="" width="auto"
            height="auto" />
          <span class="title">{{ content }}</span>
          <span class="price">{{ price }}</span>
          <span class="description">{{ description }}</span>
          <button (click)="handleClick()">{{ status === 'SUCCESS' ? 'Hoàn tất' : 'Thử lại' }}</button>
        </div>
      </div>
    </div>
  </div>
  <app-footer-hifpt></app-footer-hifpt>
</div>
<app-spinner-layout></app-spinner-layout>
